import { Controller } from "@hotwired/stimulus"

// SedeFields di components/Territorio.js: con «coincide» la sede operativa è la sede legale (anche quando la legale
// cambia o si toglie) e non è da aprire; senza, si sceglie la sede operativa e si può segnare «va aperta».
export default class extends Controller {
  static targets = ["legale", "operativaBox", "coincide", "daAprire"]

  // comune-picker:scelto da uno dei due picker: solo la sede legale, con «coincide», cambia anche l'operativa
  scelto(event) {
    if (!this.legaleTarget.contains(event.target) || !this.coincideTarget.checked) return
    this.copia(event.detail.comune)
  }

  coincide() {
    const on = this.coincideTarget.checked
    this.operativaBoxTarget.hidden = on
    if (on) this.copia(this.picker(this.legaleTarget).campoTarget.value ? JSON.parse(this.picker(this.legaleTarget).campoTarget.value) : null)
  }

  copia(sede) {
    this.picker(this.operativaBoxTarget).imposta(sede || null)
    this.daAprireTarget.checked = false
  }

  picker(box) {
    return this.application.getControllerForElementAndIdentifier(box.querySelector("[data-controller~='comune-picker']"), "comune-picker")
  }
}
